import React from "react";
type SparklineProps = {
  values: number[];
  className?: string;
};
const WIDTH = 120;
const HEIGHT = 32;
const PAD = 3;
export function Sparkline({
  values,
  className = ""
}: SparklineProps) {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const points = values.map((v, i) => [PAD + i / (values.length - 1) * (WIDTH - PAD * 2), PAD + (1 - (v - min) / range) * (HEIGHT - PAD * 2)]);
  const last = points[points.length - 1];
  return <svg aria-hidden viewBox={`0 0 ${WIDTH} ${HEIGHT}`} className={`h-8 w-full max-w-[140px] ${className}`} data-id="element-141" data-mp="1gxmtqbdz7ef0">
      <polyline points={points.map(p => p.join(",")).join(" ")} fill="none" strokeWidth={1.25} strokeLinejoin="round" className="stroke-navy" data-id="element-142" data-mp="1lykaqkn922ex" />
      <circle cx={last[0]} cy={last[1]} r={2.5} className="fill-oxblood" data-id="element-143" data-mp="3npxhlf8s2kdm" />
    </svg>;
}